import { InlineWarning } from '@driftt/tide-core-legacy'
import { Link } from 'react-router'

import { LeanDataAuthStatuses } from 'app/modules/integrations/constants'

import './style.styl'

const SALESFORCE_ACCOUNT_PAGE = "/settings/setup/salesforce"

const getErrorCopy = (error) => {
  if (LeanDataAuthStatuses.SALESFORCE_AUTHENTICATION_ISSUE === error) {
    return <p>Please <Link to={SALESFORCE_ACCOUNT_PAGE}>connect your Salesforce account </Link>and test the connection again.</p>
  }
  if (LeanDataAuthStatuses.LEANDATA_ORGANIZATION_PERMISSIONS === error) {
    return <p>It appears that your Salesforce account doesn’t have access to LeanData.<br/>
           We recommend contacting your LeanData customer success manager.<br/><br/>
           Once access has been granted, test your connection again.</p>
  }
  if (LeanDataAuthStatuses.LEANDATA_USER_PERMISSIONS === error) {
    return <p>The Salesforce account used to connect with Drift doesn’t 
          have access to LeanData. Please connect to Salesforce with a different account.<br/><br/>
           Then, test your connection again.</p>
  }
}

const LeanDataError = ({ error, testConnection }) => (
  <div>
    <InlineWarning
          title="Drift is unable to connect with LeanData"
          type="warning"
    >
     {getErrorCopy(error)}
    </InlineWarning>
  </div>
)

export default LeanDataError



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/LeanData/components/LeanDataError/index.js